<!-- ── OFFER BANNER ──────────────────────────────────────────────────── -->
<div class="offer-banner" *ngIf="showOfferBanner">
  <!-- Single centred group: icon → message → timer → CTA -->
  <div class="offer-banner__center">
    <img
      class="offer-banner__icon"
      src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f389/512.webp"
      alt="party popper"
      onerror="this.src='https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f389.png'"
    />
    <p class="offer-banner__message">
      <strong>{{ offerBannerData?.title || 'Limited Time Offer' }}</strong>
      &mdash; {{ offerBannerData?.description || '' }}
      <span *ngIf="offerBannerData?.discount" class="offer-banner__coupon">
        <img
          class="offer-banner__coupon-icon"
          src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f39f/512.webp"
          alt="coupon ticket"
          onerror="this.src='https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f39f.png'"
        />
        {{ offerBannerData?.discount }}
      </span>
    </p>

    <!-- Countdown timer -->
    <div class="offer-banner__timer">
      <span class="offer-banner__timer-label">Ends in:</span>
      <!-- Multi-day: > 24 h → "X days left" -->
      <div class="offer-banner__countdown" *ngIf="bannerCountdown.isMultiDay">
        <span class="offer-banner__days-box">
          {{ bannerCountdown.days }} {{ bannerCountdown.days === 1 ? 'day' : 'days' }} left
        </span>
      </div>
      <!-- Same-day: ≤ 24 h → HH : MM : SS -->
      <div class="offer-banner__countdown" *ngIf="!bannerCountdown.isMultiDay">
        <span class="offer-banner__time-box">{{ bannerCountdown.hours }}</span>
        <span class="offer-banner__timer-sep">:</span>
        <span class="offer-banner__time-box">{{ bannerCountdown.minutes }}</span>
        <span class="offer-banner__timer-sep">:</span>
        <span class="offer-banner__time-box">{{ bannerCountdown.seconds }}</span>
      </div>
    </div>

    <button class="offer-banner__cta" (click)="onClaimOffer()">Claim Now &#8594;</button>
  </div>

  <!-- Close: absolutely positioned so it never disturbs centring -->
  <span class="offer-banner__close" (click)="closeOfferBanner()">&#10005;</span>
</div>
<!-- ── END OFFER BANNER ───────────────────────────────────────────────── -->
<div class="module-container" *ngIf="!viewApp" [class.has-banner]="showOfferBanner">
    <button class="chatBtn" (click)="goChat()"><i class="bi bi-chat-left"></i>&nbsp; Chats</button>
    <button class="chatBtn" (click)="goPayment()"><i class="bi bi-credit-card"></i>&nbsp; Payments</button>
</div>
  
<div class="calendar-container" [ngClass]="{ 'backCont': viewApp }" [class.has-banner]="showOfferBanner">

  <!-- Listing all Appointments -->
  <div class="appointments-container" *ngIf="!viewApp">
    <div class="top-bar">
      <!-- Search -->
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search Appointments" (keydown)="preventLeadingSpace($event)" [(ngModel)]="searchQuery" (input)="onSearchChange()" />
      </div>
      <!-- Search -->

      <!-- Filters --> 
      <div class="filter-group">
        <!-- Status -->
        <div class="filter-item custom-select dropdown-wrapper" (click)="toggleStatus($event)">
          <i class="bi bi-funnel"></i>
          <span class="selected-text">{{ statusFilter }}</span>
          <i class="bi bi-chevron-down arrow"></i>
        
          <ul class="options" *ngIf="showStatusDropdown">
            <li *ngFor="let status of statusOptions" (click)="selectStatus(status, $event)"
              [class.active]="status === statusFilter">
              {{ status }}
            </li>
          </ul>
        </div>
        
        <!-- Sorting -->
        <div class="filter-item custom-select dropdown-wrapper" (click)="toggleOrder($event)">
          <i class="bi bi-sort-down"></i>
          <span class="selected-text">{{ orderFilter }}</span>
          <i class="bi bi-chevron-down arrow"></i>
        
          <ul class="options" *ngIf="showOrderDropdown">
            <li *ngFor="let o of orderOptions" (click)="selectOrder(o, $event)" [class.active]="o === orderFilter">
              {{ o }}
            </li>
          </ul>
        </div>
      
        <button class="book-btn" (click)="bookAppNew()">
          <i class="bi bi-plus-lg"></i> Book New
        </button>
      </div>
       <!-- Filters -->
    </div>

<!-- List of Appointments -->
<div class="appointments-list">
  <!-- View toggle lives here so it is always top-right, shared by both sections -->
  <div class="view-toggle">
    <button [class.active]="viewMode === 'grid'" (click)="setViewMode('grid')" matTooltip="Grid View"
      matTooltipPosition="above">
      <i class="bi bi-grid-3x3-gap"></i>
    </button>
    <button [class.active]="viewMode === 'list'" (click)="setViewMode('list')" matTooltip="List View"
      matTooltipPosition="above">
      <i class="bi bi-list-ul"></i>
    </button>
  </div>
  <!-- UPCOMING APPOINTMENTS SECTION -->
  <div class="upcoming-section" *ngIf="upcomingAppointments.length > 0 && (statusFilter === 'All Status' || statusFilter === 'Upcoming')">
    <div class="section-header">
      <h3 class="section-title" *ngIf="viewMode !== 'list'">
        Upcoming Appointments ({{ upcomingAppointments.length }})
      </h3>
       </div>

    <div class="cards upcoming-cards" *ngIf="viewMode === 'grid'">
      <div class="card upcoming-card" *ngFor="let appointment of upcomingAppointments | filter:searchQuery" (click)="goAppointmentHistory(appointment)">
        <div class="header">
          <div class="avatar" *ngIf="!appointment.profilepic_url || appointment.profilepic_url === ''">
            {{ appointment.lawyer_initials }}
          </div>
          <img *ngIf="appointment.profilepic_url && appointment.profilepic_url !== ''" 
               [src]="appointment.profilepic_url" 
               alt="{{ appointment.lawyer_name }}"
               class="avatar avatar-img" />
          <div class="info">
            <h4 class="lawyer-title-name" [matTooltip]="appointment.lawyer_name" matTooltipPosition="above">{{ appointment.lawyer_name }}</h4>
            <p>{{ appointment.specialization[0] }}</p>
          </div>
        </div>

        <div class="status">
          <span class="status-pill" [ngClass]="appointment.ui_status">
          <i class="bi" [ngClass]="{
                'bi-check-circle-fill': appointment.ui_status === 'ongoing' || appointment.ui_status === 'upcoming',
                'bi-clock': appointment.ui_status === 'payment_pending'
              }">
          </i>
          
          {{
          appointment.ui_status === 'ongoing'
          ? 'Ongoing'
          : appointment.ui_status === 'payment_pending'
          ? 'Payment Pending'
          : 'Upcoming'
          }}
        </span>
        </div>

        <!-- datetime + call-btn row: always in normal flow, never absolute -->
        <div class="card-footer-row">
          <div class="datetime">
            <i class="bi bi-clock"></i>
            <span class="appdate">{{ appointment.display_date }}</span>
          </div>
          <!-- Action buttons in flow so they never overlap the summary strip -->
          <div class="call-btn-inline">
            <span class="feature-icon chat" [class.inactive-icon]="isLawyerInactive(appointment)" [matTooltip]="isLawyerInactive(appointment) ? chatUnavailableTip(appointment) : ''" (click)="goChatApp(appointment); $event.stopPropagation()" *ngIf="appointment.actions?.chat"><i class="bi bi-chat-square-text"></i></span>
            <button class="feature-icon video" [disabled]="appointment.ui_status === 'upcoming' && !canJoinCall(appointment)" [matTooltip]="appointment.ui_status === 'upcoming' && !canJoinCall(appointment)
                ? 'You can join 1 minute before the appointment'
                : 'Join Video Call'" *ngIf="(appointment.ui_status === 'ongoing' || appointment.ui_status === 'upcoming') || appointment.actions?.join_call"
              (click)="StartVideo(appointment); $event.stopPropagation()">
              <i class="bi bi-camera-video"></i>
            </button>
          </div>
        </div>

        <button mat-icon-button [matMenuTriggerFor]="upcomingMenu" class="more-btn" (click)="$event.stopPropagation()">⋮</button>
        <mat-menu #upcomingMenu="matMenu">
          <button mat-menu-item (click)="viewAppDetails(appointment)">
            <i class="bi bi-person"></i>
            <span>Lawyer Details</span>
          </button>
          <button mat-menu-item 
          [disabled]="!canJoinCall(appointment)"
          [matTooltip]="!canJoinCall(appointment) ? 'You can join 1 minute before the appointment' : 'Join Video Call'"
          matTooltipPosition="right" (click)="StartVideo(appointment)">
            <i class="bi bi-camera-video"></i>
            <span>Join Video Call</span>
          </button>
          <button *ngIf="appointment.actions.cancel" 
                  mat-menu-item 
                  (click)="cancelApp(appointment)">
            <i class="bi bi-x-circle"></i>
            <span style="color: red;">Cancel</span>
          </button>

          <hr class="hrp" />
          <button mat-menu-item (click)="goAppointmentHistory(appointment)">
            <i class="bi bi-clock-history"></i>
            <span>Appointment History</span>
          </button>
          <button *ngIf="appointment.appointment_status !== 'cancelled'" mat-menu-item (click)="viewInvoice(appointment)">
            <i class="bi bi-receipt"></i>
            <span>View Invoice</span>
          </button>
          <button *ngIf="appointment.ui_status === 'cancelled' || appointment.ui_status === 'completed'" mat-menu-item
            (click)="deleteApp(appointment)">
            <i class="bi bi-trash3"></i>
            <span>Delete</span>
          </button>
          <span class="book-inactive-wrap" [matTooltip]="isLawyerInactive(appointment) ? inactiveLawyerTip(appointment) : ''" matTooltipPosition="left" (click)="$event.stopPropagation()">
            <button mat-menu-item [disabled]="isLawyerInactive(appointment)" (click)="goBookSlotFromAppointment(appointment); $event.stopPropagation()">
            <i class="bi bi-plus-lg"></i>
            <span>Book New Appointment</span>
            </button>
          </span>
        </mat-menu>

        <!-- ── Upcoming-Summary strip ──────────────────────────────────────── -->
        <div class="upcoming-summary-strip"
             *ngIf="appointment.upcoming_summary"
             (click)="goAppointmentHistory(appointment); $event.stopPropagation()"
             (keydown.enter)="goAppointmentHistory(appointment); $event.stopPropagation()"
             (keydown.space)="goAppointmentHistory(appointment); $event.stopPropagation()"
             role="button"
             tabindex="0">
          <span class="upcoming-summary-text">{{ appointment.upcoming_summary }}</span>
          <i class="bi bi-chevron-right upcoming-summary-arrow"></i>
        </div>
        <!-- ── /Upcoming-Summary strip ────────────────────────────────────── -->

      </div>
    </div>
  </div>

      <!-- ALL OTHER APPOINTMENTS SECTION -->
      <div class="list-header">
        <h3 class="section-title">
  {{
    viewMode === 'list'
      ? 'All Appointments'
      : (upcomingAppointments.length > 0 ? 'Past Appointments' : 'All Appointments')
  }}
  ({{ filteredAppointments.length }})
</h3>
  </div>
    
      <!-- Card/Grid View -->
      <div class="cards" *ngIf="viewMode === 'grid'">
        <div class="card" *ngFor="let appointment of filteredAppointments" (click)="goAppointmentHistory(appointment)">
          <div class="header">
            <div class="avatar" *ngIf="!appointment.profilepic_url || appointment.profilepic_url === ''">
              {{ appointment.lawyer_initials }}
            </div>
            <img *ngIf="appointment.profilepic_url && appointment.profilepic_url !== ''" 
                 [src]="appointment.profilepic_url" 
                 alt="{{ appointment.lawyer_name }}"
                 class="avatar avatar-img" />
            <div class="info">
              <h4 class="lawyer-title-name" [matTooltip]="appointment.lawyer_name" matTooltipPosition="above" (click)="viewAppDetails(appointment); $event.stopPropagation()">{{ appointment.lawyer_name }}</h4>
              <p [matTooltip]="appointment.specialization" matTooltipPosition="above">{{ appointment.specialization }}</p>
            </div>
          </div>
    
          <div class="status">
            <span class="status-pill" [ngClass]="appointment.ui_status">
              <i class="bi" [ngClass]="{
                            'bi-clock': appointment.ui_status === 'pending',
                            'bi-check-circle-fill':appointment.ui_status === 'completed' || appointment.ui_status === 'ongoing',
                            'bi-x-circle-fill': appointment.ui_status === 'cancelled'}"></i>
              {{ appointment.ui_status === 'pending' ? 'pending' : (appointment.ui_status | titlecase) }}
            </span>
          </div>
    
          <!-- datetime + call-btn row: always in normal flow, never absolute -->
          <div class="card-footer-row">
            <div class="datetime">
              <i class="bi bi-clock"></i>
              <span class="appdate">
                {{ appointment.display_date  }}
              </span>
            </div>
            <!-- Action buttons in flow so they never overlap the summary strip -->
            <div class="call-btn-inline" *ngIf="appointment.actions?.chat || appointment.actions?.join_call">
              <span class="feature-icon chat" [class.inactive-icon]="isLawyerInactive(appointment)" [matTooltip]="isLawyerInactive(appointment) ? chatUnavailableTip(appointment) : ''" (click)="goChatApp(appointment); $event.stopPropagation()" *ngIf="appointment.actions?.chat"><i class="bi bi-chat-square-text"></i></span>
              <button class="feature-icon video"
                [matTooltip]="appointment?.ui_status === 'upcoming' && !canJoinCall(appointment) ? 'You can join 1 minute before the appointment' : 'Join Video Call'"
                *ngIf="appointment.actions?.join_call" (click)="StartVideo(appointment); $event.stopPropagation()">
                <i class="bi bi-camera-video"></i>
              </button>
            </div>
          </div>
    
          <button mat-icon-button [matMenuTriggerFor]="actionMenu" class="more-btn" (click)="$event.stopPropagation()">⋮</button>
            <!-- Actions for grid view -->
            <mat-menu #actionMenu="matMenu">
              <button mat-menu-item (click)="viewAppDetails(appointment)">
                <i class="bi bi-person"></i>
                <span>Lawyer Details</span>
              </button>
              <button mat-menu-item 
                      *ngIf="appointment.actions.join_call" 
                      (click)="StartVideo(appointment)">
                <i class="bi bi-camera-video"></i>
                <span>Join Video Call</span>
              </button>
              <button *ngIf="appointment.actions.cancel" 
                      mat-menu-item 
                      (click)="cancelApp(appointment)">
                <i class="bi bi-x-circle"></i>
                <span>Cancel</span>
              </button>

              <hr class="hrp" />
              <button mat-menu-item (click)="goAppointmentHistory(appointment)">
                <i class="bi bi-clock-history"></i>
                <span>Appointment History</span>
              </button>
               <button *ngIf="appointment.appointment_status !== 'cancelled'" mat-menu-item (click)="viewInvoice(appointment)">
                <i class="bi bi-receipt"></i>
                <span>View Invoice</span>
              </button>
              <button *ngIf="appointment.ui_status === 'cancelled' || appointment.ui_status === 'completed'" mat-menu-item
                (click)="deleteApp(appointment)">
                <i class="bi bi-trash3"></i>
                <span>Delete</span>
              </button>
              <span class="book-inactive-wrap" [matTooltip]="isLawyerInactive(appointment) ? inactiveLawyerTip(appointment) : ''" matTooltipPosition="left" (click)="$event.stopPropagation()">
                <button mat-menu-item [disabled]="isLawyerInactive(appointment)" (click)="goBookSlotFromAppointment(appointment); $event.stopPropagation()">
                <i class="bi bi-plus-lg"></i>
                <span>Book New Appointment</span>
                </button>
              </span>
            </mat-menu>
            <!-- Actions for grid view -->

            <!-- ── Upcoming-Summary strip ──────────────────────────────────── -->
            <div class="upcoming-summary-strip"
                 *ngIf="appointment.upcoming_summary"
                 (click)="goAppointmentHistory(appointment); $event.stopPropagation()"
                 (keydown.enter)="goAppointmentHistory(appointment); $event.stopPropagation()"
                 (keydown.space)="goAppointmentHistory(appointment); $event.stopPropagation()"
                 role="button"
                 tabindex="0">
              <span class="upcoming-summary-text">{{ appointment.upcoming_summary }}</span>
              <i class="bi bi-chevron-right upcoming-summary-arrow"></i>
            </div>
            <!-- ── /Upcoming-Summary strip ────────────────────────────────── -->

        </div>
                
        
      </div>
    
      <!-- List View -->
      <div class="table-view" *ngIf="viewMode === 'list'">
        <div class="table-scroll">
        <table mat-table [dataSource]="pagedAppointments" class="appointments-table">

          <!-- Lawyer Name -->
          <ng-container matColumnDef="lawyer">
            <th mat-header-cell *matHeaderCellDef> Lawyer Name 
              <!-- <img class="sortarr" src="assets/icons/sortarr.svg"/>  -->
            </th>
            <td mat-cell *matCellDef="let a">
              <div class="lawyer-cell">
                <div class="avatar small" *ngIf="!a.profilepic_url || a.profilepic_url === ''">
                  {{ a.lawyer_initials }}
                </div>
                <img *ngIf="a.profilepic_url && a.profilepic_url !== ''" 
                     [src]="a.profilepic_url" 
                     alt="{{ a.lawyer_name }}"
                     class="avatar small avatar-img" />
                <div>
                  <div class="name lawyer-name-link" (click)="goAppointmentHistory(a)">{{ a.lawyer_name }}</div>
                  <div class="spec">{{ a.specialization }}</div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Date & Time -->
          <ng-container matColumnDef="datetime">
            <th mat-header-cell *matHeaderCellDef> Date & Time 
              <!-- <img class="sortarr" src="assets/icons/sortarr.svg"/>  -->
            </th>
            <td mat-cell *matCellDef="let a">
              <div class="datetime">
                <ng-container *ngIf="a.appointment_start_at; else showDate">
                  {{ a.display_date }}
                </ng-container>
                <ng-template #showDate>
                  {{ a.dateTime | date: 'EEE, MMM dd, h:mm a' }}
                </ng-template>
              </div>
            </td>
          </ng-container>

          <!-- Features -->
          <ng-container matColumnDef="features">
            <th mat-header-cell *matHeaderCellDef> Features </th>
            <td mat-cell *matCellDef="let a" class="features-cell">
              <span class="feature-icon chat" [class.inactive-icon]="isLawyerInactive(a)" [matTooltip]="isLawyerInactive(a) ? chatUnavailableTip(a) : ''" (click)="goChatApp(a)" *ngIf="a.actions?.chat"><i class="bi bi-chat-square-text"></i></span>
              <button class="feature-icon video" [disabled]="a.ui_status === 'upcoming' && !canJoinCall(a)" [matTooltip]="a.ui_status === 'upcoming' && !canJoinCall(a)
                    ? 'You can join 1 minute before the appointment'
                    : 'Join Video Call'" *ngIf="a.ui_status === 'ongoing' || a.ui_status === 'upcoming' || a.actions?.join_call"
                (click)="StartVideo(a)">
                <i class="bi bi-camera-video"></i>
              </button>
              <span *ngIf="!a.actions?.chat && !(a.ui_status === 'ongoing' || a.ui_status === 'upcoming' || a.actions?.join_call)">-</span>

            </td>
          </ng-container>

          <!-- Status -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let a">
              <span class="status-tag"
                    [ngClass]="{
                      upcoming: a.ui_status === 'upcoming',
                      ongoing: a.ui_status === 'ongoing',
                      completed: a.ui_status === 'completed',
                      cancelled: a.ui_status === 'cancelled'}">
                {{ a.ui_status | titlecase }}
              </span>
            </td>
          </ng-container>

          <!-- Action -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let a">
              <button mat-icon-button [matMenuTriggerFor]="actionMenu" (click)="selectedAppointment = a"> ⋮ </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Actions for list view -->
          <mat-menu #actionMenu="matMenu">
            <button mat-menu-item (click)="viewAppDetails(selectedAppointment)">
              <i class="bi bi-person"></i>
              <span>Lawyer Details</span>
            </button>
            <button mat-menu-item [disabled]="selectedAppointment?.ui_status === 'upcoming' && !canJoinCall(selectedAppointment)" *ngIf="selectedAppointment?.ui_status === 'upcoming'
                  || selectedAppointment?.ui_status === 'ongoing'" (click)="StartVideo(selectedAppointment)">
              <i class="bi bi-camera-video"></i>
              <span>Join Video Call</span>
            </button>

            <button mat-menu-item 
                    *ngIf="selectedAppointment?.actions?.cancel" 
                    (click)="cancelApp(selectedAppointment)">
              <i class="bi bi-x-circle"></i>
              <span style="color: red;">Cancel</span>
            </button>
                          
            <hr class="hrp" />
            <button mat-menu-item (click)="goAppointmentHistory(selectedAppointment)">
              <i class="bi bi-clock-history"></i>
              <span>Appointment History</span>
            </button>
            <button *ngIf="selectedAppointment?.appointment_status !== 'cancelled'" mat-menu-item (click)="viewInvoice(selectedAppointment)">
              <i class="bi bi-receipt"></i>
              <span>View Invoice</span>
            </button>
            <button *ngIf="selectedAppointment?.ui_status === 'cancelled' || selectedAppointment?.ui_status === 'completed'" mat-menu-item
              (click)="deleteApp(selectedAppointment)">
              <i class="bi bi-trash3"></i>
              <span>Delete</span>
            </button>
            <span class="book-inactive-wrap" [matTooltip]="isLawyerInactive(selectedAppointment) ? inactiveLawyerTip(selectedAppointment) : ''" matTooltipPosition="left" (click)="$event.stopPropagation()">
              <button mat-menu-item [disabled]="isLawyerInactive(selectedAppointment)" (click)="goBookSlotFromAppointment(selectedAppointment); $event.stopPropagation()">
              <i class="bi bi-plus-lg"></i>
              <span>Book New Appointment</span>
              </button>
            </span>
          </mat-menu>
          <!-- Actions for list view -->

        </table>
        </div>

        <!-- Pagination -->
        <div class="pagination">
        <span class="pagination-info-text">
          {{ (pageIndex * pageSize) + 1 }} - {{ endIndex }} of {{ filteredAppointments.length }} items
        </span>

          <div class="pagination-buttons">
            <button [disabled]="pageIndex === 0" (click)="prevPage()" class="page-btn">
              <i class="bi bi-chevron-left"></i> Previous
            </button>
            <button [disabled]="(pageIndex + 1) * pageSize >= filteredAppointments.length" (click)="nextPage()" class="page-btn">
              Next <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
        <!-- Pagination -->
      </div>

  </div>
    <!-- List of Appointments -->
</div>
  <!-- Listing all Appointments -->

  <!-- View Details -->
  <div *ngIf="viewApp" class="lawyer-details-view">
    <div class="history-header">
      <button class="back-btn" (click)="goBack()">
        <i class="bi bi-chevron-left"></i>
      </button>
      <span class="header-title">Lawyer Details</span>
    </div>

  <!-- View Details -->
  <div class="appointment-details">

    <!-- Lawyer Profile -->
    <div class="lawyer-profile">
      <div class="profile-header">
        <div class="avatar2" *ngIf="!viewAppointments.lawyer?.profilepic_url || viewAppointments.lawyer?.profilepic_url === ''">
          {{viewAppointments.lawyer?.lawyer_initials}}
        </div>
        <img *ngIf="viewAppointments.lawyer?.profilepic_url && viewAppointments.lawyer?.profilepic_url !== ''" 
             [src]="viewAppointments.lawyer.profilepic_url" 
             alt="{{ viewAppointments.lawyer?.name }}"
             class="avatar2 avatar-img" />
        <h3>{{viewAppointments.lawyer?.name}}</h3>
      </div>

      <p class="bio">{{viewAppointments.lawyer?.bio_description}}
      </p>


      <!-- Tabs -->
      <div class="tabs">
        <button class="tab" [class.active]="activeTab === 'personal'" (click)="setActiveTab('personal')">Personal</button>
        <button class="tab" [class.active]="activeTab === 'credentials'" (click)="setActiveTab('credentials')">Credentials</button>
        <button class="tab" [class.active]="activeTab === 'practice'" (click)="setActiveTab('practice')">Practice</button>
        <!-- <button class="tab" [class.active]="activeTab === 'schedule'" (click)="setActiveTab('schedule')">Schedule</button> -->
      </div>

      <!-- Personal -->
      <div class="tab-content" *ngIf="activeTab === 'personal'">
        <div class="info-grid">
          <div class="info-item">
            <label>Gender</label>
            <p>{{(viewAppointments.lawyer?.gender | titlecase) || ''}}</p>
          </div>
          <div class="info-item">
            <label>Nationality</label>
            <p>{{viewAppointments.lawyer?.nationality || ''}}</p>
          </div>
          <div class="info-item">
            <label>Date of Birth</label>
            <p>{{viewAppointments.lawyer?.date_of_birth ? (viewAppointments.lawyer.date_of_birth | date:'mediumDate') : ''}}</p>
          </div>
        </div>
      </div>
      <!-- Personal -->

      <!-- Credential - UPDATED with 3 columns -->
      <div class="tab-content" *ngIf="activeTab === 'credentials'">
        <div class="credentials-section">
          
          <!-- Row 1: License Information & Experience (2 columns) -->
          <div class="cred-row">
            <div class="info-block">
              <h4 class="cred-info">License Information</h4>
              <p class="cred-info">{{viewAppointments.lawyer?.bar_council_id || ''}}</p>
            </div>
            <div class="info-block">
              <h4 class="cred-info">Experience</h4>
              <p class="cred-info" *ngIf="viewAppointments.lawyer?.years_of_experience != null">{{viewAppointments.lawyer?.years_of_experience}} years</p>
            </div>
          </div>

          <!-- Row 2: Educational Qualifications, Certifications, Awards (3 columns) -->
          <div class="cred-row three-col">
            <div class="grid-col">
              <h4 class="cred-info">Educational Qualifications</h4>
              <div class="tag" *ngFor="let e of viewAppointments.lawyer?.education">
                <p class="eqDeg">{{e.degree}}</p>
                <span class="eqSchool">{{e.university}} • {{e.passing_year}}</span>
              </div>
            </div>

            <div class="grid-col">
              <h4 class="cred-info">Certifications</h4>
              <div class="tag" *ngFor="let c of viewAppointments.lawyer?.certifications">
                <p class="eqDeg">{{c.certification_name}}</p>
                <span class="eqSchool">{{c.issuing_authority}} • {{c.year_of_issue}}</span>
              </div>
            </div>

            <div class="grid-col">
              <h4 class="cred-info">Awards & Recognitions</h4>
              <div class="tag" *ngFor="let a of viewAppointments.lawyer?.awards">
                <p class="eqDeg">{{a.award_name}}</p>
                <span class="eqSchool">{{a.purpose}} • {{a.year_of_award}}</span>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- Credential -->

      <!-- Practice - UPDATED with reordered layout -->
      <div class="tab-content" *ngIf="activeTab === 'practice'">
        <div class="practice-section">

          <!-- Row 1: Consultation Fee, Practice Areas, Services Offered (3 columns) -->
          <div class="practice-grid">
            <div class="grid-col">
              <h4>Consultation Fee</h4>
              <p class="practiceFee">
                <span class="price">₹ {{viewAppointments?.consultation_fee}}</span>
                <span class="per">per session</span>
              </p>
            </div>

            <div class="grid-col">
              <h4>Practice Areas</h4>
              <div class="chip claw" *ngFor="let p of viewAppointments.lawyer?.practice_areas">{{p}}</div>
            </div>

            <div class="grid-col">
              <h4>Services Offered</h4>
              <div class="chip pst" *ngFor="let s of viewAppointments.lawyer?.services_offered">
                {{s}}
              </div>
            </div>
          </div>

          <!-- Row 2: Languages Spoken (full width) -->
          <div class="practice-grid" style="margin-top: 25px;">
            <div class="grid-col" style="grid-column: 1 / -1;">
              <h4>Languages Spoken</h4>
              <div class="chip lspoke" *ngFor="let l of viewAppointments.lawyer?.languages_spoken">{{l}}</div>
            </div>
          </div>

        </div>
      </div>
      <!-- Practice -->

    </div>

  </div>
  <!-- View Details -->
  </div>

</div>

<!-- ─── T&C Agreement Overlay ─────────────────────────────────────────────── -->
<div class="terms-overlay" *ngIf="showTermsModal">
  <div class="terms-dialog">

    <div class="terms-header">
      <h2>Terms &amp; Conditions</h2>
    </div>

    <div class="terms-body">
      <iframe *ngIf="safeTermsUrl" [src]="safeTermsUrl" class="terms-iframe"></iframe>
      <div *ngIf="!safeTermsUrl" class="no-preview">
        <p>Unable to load document.</p>
        <a [href]="termsUrl" target="_blank">Open Terms</a>
      </div>
    </div>

    <div class="terms-footer">
      <div class="checkbox-section">
        <input type="checkbox" id="agreeCheck" [(ngModel)]="isChecked" />
        &nbsp;<label for="agreeCheck">
          By clicking this, you agree to the
          <a style="text-decoration: underline;" href="https://digicoffer.com/digicoffer_privacy.pdf" target="_blank">Privacy Policy</a>
          and
          <a style="text-decoration: underline;" href="https://digicoffer.com/digicoffer_cookie.pdf" target="_blank">Cookies Policy</a>,
          along with the Terms &amp; Conditions.
        </label>
      </div>

      <div class="action-buttons">
        <button class="btn cancel-btn" (click)="cancelTerms()">Cancel</button>
        <button class="btn agree-btn" [disabled]="!isChecked" (click)="agreeTerms()">
          Agree &amp; Continue
        </button>
      </div>
    </div>

  </div>
</div>

<!-- Shared invoice PDF viewer (see invoice-pdf-viewer.component.ts for why this
     is a separate small component instead of the Documents module's viewer) -->
<app-invoice-pdf-viewer
  [isOpen]="isInvoicePreviewOpen"
  [isLoading]="isInvoicePreviewLoading"
  [previewUrl]="invoicePreviewUrl"
  [title]="invoiceTitle"
  (closed)="closeInvoicePreview()">
</app-invoice-pdf-viewer>